import { configureStore } from "@reduxjs/toolkit";
import configSlice from "./slices/userDataStore";

const appStore = configureStore({
  reducer: {
    config: configSlice,
  },
});

export default appStore;
